import src from "IMAGE";
export default { src, width: 18, height: 18, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
